import {
  AppointmentTypeEnum,
  CodexSubscriptionStatuses,
  PriceCategory,
  ProviderEducationOutput,
  ServiceType,
} from 'graphql/generated/hasura';
import { SelectProviderValue } from '../../interfaces';
import { PatientRequest } from '../../../../graphql/generated/remote-schema-hasura';

export interface ProviderCredentialsOutput {
  titles: string[];
  states?: string[];
  certifications?: string[];
  medicalRole: string;
  yearsOfPractice: string;
}

export interface AddressInformationOutput {
  address1?: string | null;
  city?: string | null;
  state?: string | null;
  officeName?: string | null;
  email?: string | null;
}

const ServiceTypeAppointment = {
  [ServiceType.Chat]: AppointmentTypeEnum.Chat,
  [ServiceType.Chat_30]: AppointmentTypeEnum.Chat_30,
  [ServiceType.Chat_60]: AppointmentTypeEnum.Chat_60,
  [ServiceType.Video]: AppointmentTypeEnum.Video,
  [ServiceType.Video_30]: AppointmentTypeEnum.Video_30,
  [ServiceType.Video_60]: AppointmentTypeEnum.Video_60,
  Messaging: AppointmentTypeEnum.Email,
};

export function parseServiceType(
  serviceType: ServiceType,
): AppointmentTypeEnum {
  return ServiceTypeAppointment[serviceType];
}
export interface ServiceOfferingType {
  serviceType: AppointmentTypeEnum;
  serviceLabel?: string;
  active?: boolean;
  healthCareServiceFhirId?: string;
  price: string;
  priceCategory?: PriceCategory;
}

export interface ProviderOutput {
  patientRequests: Array<PatientRequest>;
  id: string;
  SENSITIVE_firstname: string;
  SENSITIVE_lastname: string;
  SENSITIVE_address_information?: AddressInformationOutput | null;
  SENSITIVE_office_information?: AddressInformationOutput | null;
  SENSITIVE_education?: ProviderEducationOutput[];
  SENSITIVE_credentials: ProviderCredentialsOutput;
  SENSITIVE_profile_picture_id?: string | null;
  accepted_appointment_types: ServiceOfferingType[];
  isFavorite?: boolean;
  acuityOwnerId?: string | null;
  acuityCalendarId?: string | null;
  subscriptionPeriodEnd?: string | null;
  subscriptionStatus?: CodexSubscriptionStatuses | null;
}

export interface ProviderCardProps {
  providerInfo: ProviderOutput;
  onSelect: (value: SelectProviderValue) => void;
}
